import { writable } from "svelte/store";

function jsonStore() {
  const { subscribe, set } = writable([]);

  async function fetchData(url) {
    return await fetch(url).then((resp) => resp.json());
  }

  return {
    subscribe,
    init: (initData) => set(initData),
    load: async (url) => set(await fetchData(url)),
  };
}

function tooltipStore() {
  const { subscribe, set, update } = writable({
    x: 0,
    y: 0,
    visible: false,
    isMobile: false,
    data: {},
  });

  function init(defaultData) {
    return set({
      x: 0,
      y: 0,
      visible: false,
      isMobile: false,
      data: defaultData,
    });
  }

  function updateData(d) {
    return update((n) => Object.assign(n, { data: d }));
  }

  function mousemove(e) {
    const position = {
      x: e.clientX,
      y: e.clientY,
    };
    return update((n) => Object.assign(n, position));
  }

  function changePosition(x, y) {
    return update((n) => Object.assign(n, { x: x, y: y }));
  }

  function hide() {
    return update((n) => Object.assign(n, { visible: false }));
  }

  function show() {
    return update((n) => Object.assign(n, { visible: true }));
  }

  function setMobileState(isMobile) {
    return update((n) => Object.assign(n, { isMobile: isMobile }));
  }

  function keydown(e) {
    if (e.code === "Escape") {
      return hide();
    } else if (e.code === "Space") {
      return show();
    }
  }

  return {
    subscribe,
    init,
    updateData,
    mousemove,
    keydown,
    changePosition,
    hide,
    show,
    setMobileState,
  };
}

export { jsonStore, tooltipStore };
